if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.container = this.querySelector('[role="document"]');
        this.previousButton = this.querySelector('[data-media-modal-prev]');
        this.nextButton = this.querySelector('[data-media-modal-next]');
        this.counter = this.querySelector('[data-media-modal-counter]');
        this.currentCounter = this.querySelector('[data-media-modal-current]');
        this.totalCounter = this.querySelector('[data-media-modal-total]');

        this.previousButton?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.showPreviousMedia();
        });
        this.nextButton?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.showNextMedia();
        });

        // Prevent media-modal pointerup handler from closing the modal when navigating.
        this.previousButton?.addEventListener('pointerup', (event) => event.stopPropagation());
        this.nextButton?.addEventListener('pointerup', (event) => event.stopPropagation());

        this.addEventListener('keydown', (event) => {
          if (!this.hasAttribute('open')) return;

          if (event.code.toUpperCase() === 'ARROWLEFT') {
            event.preventDefault();
            this.showPreviousMedia();
          }

          if (event.code.toUpperCase() === 'ARROWRIGHT') {
            event.preventDefault();
            this.showNextMedia();
          }
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      getMediaItems() {
        if (!this.container) return [];
        return Array.from(this.container.querySelectorAll('[data-media-id]')).filter(
          (element) => element.parentElement === this.container
        );
      }

      showActiveMedia() {
        const mediaId = this.openedBy?.getAttribute('data-media-id');
        this.activateMedia(mediaId);
      }

      activateMedia(mediaId) {
        const mediaItems = this.getMediaItems();
        if (!mediaItems.length) return;

        let activeMedia = mediaItems.find((item) => item.dataset.mediaId === mediaId);
        if (!activeMedia) {
          activeMedia = mediaItems[0];
        }

        mediaItems.forEach((element) => {
          element.classList.toggle('active', element === activeMedia);
        });

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.scrollIntoView({ block: 'nearest', inline: 'center' });

        if (this.container && activeMedia.clientWidth) {
          this.container.scrollLeft = Math.max(0, (activeMedia.clientWidth - this.container.clientWidth) / 2);
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();

        this.updateControls(mediaItems, activeMedia);
      }

      showPreviousMedia() {
        this.stepMedia(-1);
      }

      showNextMedia() {
        this.stepMedia(1);
      }

      stepMedia(direction) {
        const mediaItems = this.getMediaItems();
        if (mediaItems.length < 2) return;

        const currentIndex = mediaItems.findIndex((item) => item.classList.contains('active'));
        const activeIndex = currentIndex === -1 ? 0 : currentIndex;
        const nextIndex = (activeIndex + direction + mediaItems.length) % mediaItems.length;
        this.activateMedia(mediaItems[nextIndex].dataset.mediaId);
      }

      updateControls(mediaItems, activeMedia) {
        const total = mediaItems.length;
        const activeIndex = mediaItems.findIndex((item) => item === activeMedia);
        const controlsEnabled = total > 1;

        if (this.currentCounter) this.currentCounter.textContent = String(activeIndex + 1);
        if (this.totalCounter) this.totalCounter.textContent = String(total);

        if (this.counter) {
          if (controlsEnabled) {
            this.counter.removeAttribute('hidden');
          } else {
            this.counter.setAttribute('hidden', 'hidden');
          }
        }

        if (this.previousButton) {
          if (controlsEnabled) {
            this.previousButton.removeAttribute('hidden');
          } else {
            this.previousButton.setAttribute('hidden', 'hidden');
          }
        }

        if (this.nextButton) {
          if (controlsEnabled) {
            this.nextButton.removeAttribute('hidden');
          } else {
            this.nextButton.setAttribute('hidden', 'hidden');
          }
        }
      }
    }
  );
}
